/* ========================================================================
   new-arrivals 専用のページネーション描画
   ======================================================================== */
(() => {
  const AuremePlpUtils = window.AuremePlpUtils;
  const AuremePlpNewArrival = window.AuremePlpNewArrival;
  if (!AuremePlpUtils || !AuremePlpNewArrival) return;

  const NEW_ARRIVAL_PAGINATION_WINDOW = 5;

  const { buildSearchUrl } = AuremePlpUtils;
  const { buildNewArrivalPageSearchParams } = AuremePlpNewArrival;

  function getNewArrivalPaginationContainer(sectionId) {
    return sectionId ? document.getElementById(`AuremePlpPagination-${sectionId}`) : null;
  }

  function getNewArrivalPaginationIconMarkup(sectionId) {
    return sectionId
      ? document.getElementById(`AuremePlpPaginationIcon-${sectionId}`)?.innerHTML || ''
      : '';
  }

  function getNewArrivalPaginationParts(currentPage, totalPages) {
    if (totalPages <= NEW_ARRIVAL_PAGINATION_WINDOW) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, 'ellipsis', totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [1, 'ellipsis', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, 'ellipsis', currentPage - 1, currentPage, currentPage + 1, 'ellipsis', totalPages];
  }

  /* ページネーション本体では分岐だけを追えるよう、各要素のマークアップ生成を helper に分ける */
  function buildNewArrivalPaginationArrowItem(
    baseSearchParams,
    page,
    ariaLabel,
    iconMarkup,
    modifierClass,
  ) {
    return `
      <li>
        <a
          href="${buildSearchUrl(buildNewArrivalPageSearchParams(baseSearchParams, page))}"
          class="pagination__item ${modifierClass} pagination__item-arrow link motion-reduce"
          aria-label="${ariaLabel}"
          data-aureme-new-arrival-pagination-link
          data-page="${page}"
        >
          ${iconMarkup}
        </a>
      </li>
    `;
  }

  function buildNewArrivalPaginationCurrentItem(page, pageLabel) {
    return `
      <li>
        <a
          role="link"
          aria-disabled="true"
          class="pagination__item pagination__item--current light"
          aria-current="page"
          aria-label="${pageLabel}"
        >
          ${page}
        </a>
      </li>
    `;
  }

  function buildNewArrivalPaginationLinkItem(baseSearchParams, page, pageLabel) {
    return `
      <li>
        <a
          href="${buildSearchUrl(buildNewArrivalPageSearchParams(baseSearchParams, page))}"
          class="pagination__item link"
          aria-label="${pageLabel}"
          data-aureme-new-arrival-pagination-link
          data-page="${page}"
        >
          ${page}
        </a>
      </li>
    `;
  }

  function buildNewArrivalPaginationPartItem(part, currentPage, baseSearchParams, config) {
    if (part === 'ellipsis') {
      return '<li><span class="pagination__item">…</span></li>';
    }

    const pageLabel = config.pageLabelTemplate.replaceAll('__NUMBER__', String(part));
    if (part === currentPage) {
      return buildNewArrivalPaginationCurrentItem(part, pageLabel);
    }

    return buildNewArrivalPaginationLinkItem(baseSearchParams, part, pageLabel);
  }

  function renderNewArrivalPagination(config, baseSearchParams, currentPage, totalPages) {
    const paginationContainer = getNewArrivalPaginationContainer(config.sectionId);
    if (!paginationContainer) return;

    if (totalPages <= 1) {
      paginationContainer.hidden = true;
      paginationContainer.innerHTML = '';
      return;
    }

    const paginationParts = getNewArrivalPaginationParts(currentPage, totalPages);
    const showPaginationArrows = totalPages > NEW_ARRIVAL_PAGINATION_WINDOW;
    const paginationIconMarkup = getNewArrivalPaginationIconMarkup(config.sectionId);
    const paginationItems = paginationParts.map((part) =>
      buildNewArrivalPaginationPartItem(part, currentPage, baseSearchParams, config),
    );

    /*
     * 共通 pagination.liquid と同じ modifier class を使い、
     * Dawn の icon 回転 CSS を new-arrivals の仮想ページネーションでも流用する。
     */
    if (showPaginationArrows && currentPage > 1) {
      const previousPage = currentPage - 1;
      paginationItems.unshift(
        buildNewArrivalPaginationArrowItem(
          baseSearchParams,
          previousPage,
          config.previousLabel,
          paginationIconMarkup,
          'pagination__item--next',
        ),
      );
    }

    if (showPaginationArrows && currentPage < totalPages) {
      const nextPage = currentPage + 1;
      paginationItems.push(
        buildNewArrivalPaginationArrowItem(
          baseSearchParams,
          nextPage,
          config.nextLabel,
          paginationIconMarkup,
          'pagination__item--prev',
        ),
      );
    }

    paginationContainer.hidden = false;
    paginationContainer.innerHTML = `
      <div
        class="pagination-wrapper pagination-wrapper--editorial${showPaginationArrows ? ' pagination-wrapper--editorial-arrows' : ''}"
        data-page="${currentPage}"
      >
        <nav
          class="pagination pagination--editorial pagination--aureme-figma"
          role="navigation"
          aria-label="${config.paginationLabel}"
        >
          <ul class="pagination__list list-unstyled" role="list">
            ${paginationItems.join('')}
          </ul>
        </nav>
      </div>
    `;
  }

  window.AuremePlpNewArrival = Object.assign(window.AuremePlpNewArrival || {}, {
    renderNewArrivalPagination,
  });
})();
